import React from 'react';
import { TextField } from '@mui/material';

/**
 * HO-148 Task 6 whitelist kategorii podkladu zpravy (BE
 * `PodkladService#PLATNE_KATEGORIE`, CHECK `ck_kz_kategorie`/`ck_p_kategorie`
 * v `111-chat-jadro.sql`). Prekladove popisky prevzate z BE
 * `PodkladService#kategorieLabel` - nic navic nevymysleji.
 *
 * `OSTATNI` schvalne CHYBI jako volba: BE mapuje `kategorie === null` i
 * doslovne `"OSTATNI"` na stejny popisek "Ostatni" (viz `kategorieLabel`),
 * takze dve oddelene volby by v podkladu vypadaly totozne a uzivatele by
 * jen matly. "Bez kategorie" (hodnota `null`) pokryva oba pripady.
 */
const KATEGORIE: { hodnota: string; label: string }[] = [
    { hodnota: 'PRUZKUM', label: 'Průzkum' },
    { hodnota: 'LOKALIZACE', label: 'Lokalizace' },
    { hodnota: 'LIKVIDACE', label: 'Likvidace' },
    { hodnota: 'PREDANI', label: 'Předání' },
    { hodnota: 'SKODA', label: 'Škoda' },
    { hodnota: 'ZRANENI', label: 'Zranění' },
    { hodnota: 'SPOTREBA', label: 'Spotřeba' },
];

interface VyberKategorieProps {
    hodnota: string | null;
    onZmena: (kategorie: string | null) => void;
    disabled?: boolean;
}

/**
 * Vyber volitelne kategorie oznacene polozky podkladu (HO-151 Task 2).
 * Native `<select>` (`SelectProps={{ native: true }}`) misto MUI `Menu` -
 * volby jsou vzdy v DOM, ne az po otevreni rozbalovaciho seznamu.
 */
const VyberKategorie: React.FC<VyberKategorieProps> = ({ hodnota, onZmena, disabled = false }) => {
    return (
        <TextField
            select
            size="small"
            label="Kategorie"
            value={hodnota ?? ''}
            onChange={(event) => onZmena(event.target.value === '' ? null : event.target.value)}
            disabled={disabled}
            SelectProps={{ native: true }}
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: 160 }}
        >
            <option value="">Bez kategorie</option>
            {KATEGORIE.map((k) => (
                <option key={k.hodnota} value={k.hodnota}>
                    {k.label}
                </option>
            ))}
        </TextField>
    );
};

export default VyberKategorie;
